import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SpinnerStateEffects } from '@ninety/platform/state';

import { LearnSupportMenuEffects } from '../main-layout/learn-support-menu/learn-support-menu.effects';
import { MeetingPrepPanelAnalyticsEffects } from '../meeting-prep-panel/meeting-prep-panel-analytics.effects';
import { provideUniversalCreateRootAdapters } from '../services/universal-create-root-adapters';

import { FilterBarStateEffects } from './filterbar/filterbar-state.effects';
import { GlobalSearchAnalyticsEffects } from './global-search/global-search-analytics.effects';
import { GlobalSearchEffects } from './global-search/global-search-state.effects';
import { LayoutAnalyticsEffects } from './layout-analytics.effects';
import { TopToolbarEffects } from './top-toolbar/top-toolbar-state.effects';
import { UniversalCreateEffects } from './universal-create/universal-create.effects';

import { LayoutStateKey, layoutStateReducers } from './index';

@NgModule({
  imports: [
    StoreModule.forFeature(LayoutStateKey, layoutStateReducers),
    EffectsModule.forFeature([
      FilterBarStateEffects,
      SpinnerStateEffects,
      TopToolbarEffects,
      UniversalCreateEffects,
      LayoutAnalyticsEffects,
      LearnSupportMenuEffects,
      GlobalSearchEffects,
      GlobalSearchAnalyticsEffects,
      MeetingPrepPanelAnalyticsEffects,
    ]),
  ],
  providers: [provideUniversalCreateRootAdapters()],
})
export class LayoutStateModule {}
